export const APP_CHROME_HEIGHT_CLASS = 'h-14'
